export enum UnifiedBallotStatus {
    created = 0,
    scheduled = 1,
    openForVoting = 2,
    closedForVoting = 3,
    finalised = 4,
    pendingClosure = 5,
    deferred = 6,
    onHold = 7,
    pendingFinalisedApproval = 8,
    reviewComplete = 9
}